import React from "react";


interface Props {
    bodyMsg: string;
    title: string;
    isEng: boolean;
}

export class GeneralCalloutComponent extends React.Component<Props> {

    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);

    }

    generateHtmlString = () => {
        let html = [];
        let bodyMsg = this.props.bodyMsg;
        let title = this.props.title;

        html.push(
            <div className="ontario-callout ontario-border-highlight--teal">
                {title ? 
                <h4 className="ontario-callout__title ontario-h4">{title}</h4>
                : <div></div>}
                <p>{bodyMsg}</p>
            </div>
        );
        return html;

    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
